import { PractitionerSpecialtyAssociation } from '../models/Entities/PractitionerAssociations/Specialties/PractitionerSpecialtyAssociation';
import { NewPractitionerSpecialtyAssociation } from '../models/Entities/PractitionerAssociations/Specialties/NewPractitionerSpecialtyAssociation';

// Functions
import * as Functions from '../functions/common';

// Error Tracer
import * as Sentry from '@sentry/react';

const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'practitioners/associations/';

export const GetAllPractitionerSpecialties = async (
  practitionerId: string,
  token: string
): Promise<PractitionerSpecialtyAssociation[]> => {
  const RequestURL: string = BaseURL + practitionerId + '/specialties';

  try {
    const Response: PractitionerSpecialtyAssociation[] = await fetch(
      RequestURL,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token
        },
        method: 'GET'
      }
    )
      .then((response) => {
        if (!response.ok) {
          throw response;
        } else {
          return response.json() as Promise<{ data: PractitionerSpecialtyAssociation[] }>;
        }
      })
      .then((data: { data: PractitionerSpecialtyAssociation[] }) => {
        return data.data;
      })
      .catch((error: any) => {
        throw error.text
          ? error.text().then((body: any) => Functions.HttpErrorHandler(body, error))
          : Functions.HttpErrorHandler(null, error);
      });

    return Response;
  } catch (error: any) {
    Sentry.captureException(error);
    throw error;
  }
};

export const AssociatePractitionerSpecialty = async (
  association: NewPractitionerSpecialtyAssociation,
  token: string
): Promise<PractitionerSpecialtyAssociation> => {
  const RequestURL: string = BaseURL + 'specialties/';

  try {
    const Response: PractitionerSpecialtyAssociation = await fetch(
      RequestURL,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token
        },
        method: 'POST',
        body: JSON.stringify(association)
      }
    )
      .then((response) => {
        if (!response.ok) {
          throw response;
        } else {
          return response.json() as Promise<{ data: PractitionerSpecialtyAssociation }>;
        }
      })
      .then((data: { data: PractitionerSpecialtyAssociation }) => {
        return data.data;
      })
      .catch((error: any) => {
        throw error.text
          ? error.text().then((body: any) => Functions.HttpErrorHandler(body, error))
          : Functions.HttpErrorHandler(null, error);
      });

    return Response;
  } catch (error: any) {
    Sentry.captureException(error);
    throw error;
  }
};

export const DisassociatePractitionerSpecialtyById = async (
  associationId: number,
  token: string
): Promise<number> => {
  const RequestURL: string = BaseURL + 'specialties/' + associationId;

  try {
    const Response: number = await fetch(
      RequestURL,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token
        },
        method: 'DELETE'
      }
    )
      .then((response) => {
        if (!response.ok) {
          throw response;
        } else {
          return response.json() as Promise<{ data: number }>;
        }
      })
      .then((data: { data: number }) => {
        return data.data;
      })
      .catch((error: any) => {
        throw error.text
          ? error.text().then((body: any) => Functions.HttpErrorHandler(body, error))
          : Functions.HttpErrorHandler(null, error);
      });

    return Response;
  } catch (error: any) {
    Sentry.captureException(error);
    throw error;
  }
};
